export const environment = {
  production: true,
  firebase : {
      apiKey: "AIzaSyDFYSxxS-AABDYURvP8KXRB6lHZNwY-Gq8",
      authDomain: "iwuzzler-web-app.firebaseapp.com",
      projectId: "iwuzzler-web-app",
      storageBucket: "iwuzzler-web-app.appspot.com",
      messagingSenderId: "322399089179",
      appId: "1:322399089179:web:81f9d473faa34dc592bebe"
    }
};
